import { render, staticRenderFns } from "./EditorTabs.vue?vue&type=template&id=ae85ff2e"
import script from "./EditorTabs.vue?vue&type=script&lang=js"
export * from "./EditorTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports